<template>
  <li><router-link :to="'/selling/' + productCategory.slug">{{productCategory.description}}</router-link></li>
</template>

<script>

export default {
  name: 'product-group-navigation-item',
  props: ['productCategory', 'groupSlug'],
};
</script>



// WEBPACK FOOTER //
// src/components/common/ProductGroupNavigationItem.vue